import { defineNuxtPlugin } from '#app'

// This Nuxt plugin performs the following actions:
// 1. Creates and mounts a component in the DOM to display a loading state.
// 2. Removes the loading component after the page loading is completed.

export default defineNuxtPlugin((nuxtApp) => {
  const route = useRoute()
  const routeName = route.name as string

  if (routeName.startsWith('app') || routeName.startsWith('influenciador-')) {
    handleLoading(nuxtApp)
  }
})

function handleLoading(nuxtApp: any) {
  // Check if the code is running on the client side (not on the server).
  if (import.meta.client && document && document.body) {
    // Create a 'div' element to display the loading component.
    const loaderHtmlComponent = document.createElement('div')
    // Insert the HTML code for the loading component, specified in the plugin options.
    loaderHtmlComponent.innerHTML = `<div id="loading" data-testid="spa-loading" style="display: flex; position: absolute; top: 0; left: 0; right: 0; bottom: 0; justify-content: center; align-items: center;">
  <img src="/assets/images/splash.gif" alt="loading" style="width: 100px;" />
</div>

<script>
  const nuxtColorMode = localStorage.getItem('nuxt-color-mode')
  const darkColor = '#1e293b'
  const lightColor = '#ffffff'

  const getPreferredScheme = () => window?.matchMedia?.('(prefers-color-scheme:dark)')?.matches ? 'dark' : 'light'

  if (nuxtColorMode && nuxtColorMode === 'dark') {
    document.body.style.backgroundColor = darkColor
  } else if (nuxtColorMode && nuxtColorMode === 'light') {
    document.body.style.backgroundColor = lightColor
  } else if (getPreferredScheme() === 'dark') {
    document.body.style.backgroundColor = darkColor
  } else {
    document.body.style.backgroundColor = lightColor
  }
</script>
`
    // Insert the loading component at the beginning of the document's body.
    document.body.insertBefore(loaderHtmlComponent, document.body.firstChild)

    // Register the 'page:finish' hook to perform actions after page loading is complete.
    nuxtApp.hook('page:finish', () => {
      if (loaderHtmlComponent) {
        // Remove the loading component after the delay.
        loaderHtmlComponent.remove()
      }
    })
  }
}
